import { render, staticRenderFns } from "./UserLimits.vue?vue&type=template&id=20009a24&scoped=true"
import script from "./UserLimits.vue?vue&type=script&lang=js"
export * from "./UserLimits.vue?vue&type=script&lang=js"
import style0 from "./UserLimits.vue?vue&type=style&index=0&id=20009a24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20009a24",
  null
  
)

export default component.exports